import React from "react";
import { CurrencyFormat, ListFormat } from "../../../Formatters";

export default function AboutData(minAge, maxAge, minCoverageAmount, maxCoverageAmount, termLengths) {
    return {
        title: "About Term Life Insurance",
        content:
            "Term life insurance is the most affordable way to secure coverage. With term insurance, you can lock in a death benefit at a fixed cost for a set length of time, usually from 10 to 40 years. The death benefit is typically tax-free and can help pay off your mortgage, cover living expenses, education costs, debts, loans, final expenses and more.",
        productData: [
            {
                title: "Who can apply?",
                text: `U.S. citizens or permanent residents ages ${minAge}-${maxAge}`
            },
            {
                title: "Term Lengths",
                text: <span><ListFormat numbers={termLengths.map(n => n.value)} /> years</span>,
            },
            {
                title: "Coverage Amounts",
                text: <span><CurrencyFormat number={minCoverageAmount} whole /> - <CurrencyFormat number={maxCoverageAmount} whole /></span>,
            },
            {
                title: "Death Benefit",
                text: "Lump sum payment, that is typically paid tax free"
            },
        ]
    };
}
